import {z} from 'zod';

const documentSeriesSchema = z.object({
  docSeriesId: z.string().nullish(),
});

const templateAndDocSeriesSchema = z.object({
  templateId: z.string().nullish(),
  docSeriesId: z.string().nullish(),
});

export const depositMethodSchema = z.object({
  isAllowed: z.boolean(),
  taxDocument: templateAndDocSeriesSchema.nullish(),
  taxDocumentEu: documentSeriesSchema.nullish(),
  taxDocumentOutsideEu: documentSeriesSchema.nullish(),
  taxDocumentCorrection: documentSeriesSchema.nullish(),
  taxDocumentCorrectionEu: documentSeriesSchema.nullish(),
  taxDocumentCorrectionOutsideEu: documentSeriesSchema.nullish(),
});

export type DepositMethodFormValues = z.infer<typeof depositMethodSchema>;
